export default function jumpLinks () {
    const jumpNav = document.getElementById("jump-nav");
    const firstCard = document.querySelector(".two-columns__grid");
    const toggleButton = document.querySelector('.jump-nav__toggle');
    const jumpLinks = document.querySelectorAll('#jump-nav a[href^="#"]');

    if (!jumpNav || !firstCard || !jumpLinks.length) return;

    const sectionIds = Array.from(jumpLinks).map(link => link.getAttribute('href').substring(1));
    const sections = sectionIds.map(id => document.getElementById(id));

    window.addEventListener("scroll", () => {
        const top = firstCard.getBoundingClientRect().top;
        const twoColumns = document.querySelector(".two-columns");
        const twoColumnsBottom = twoColumns.getBoundingClientRect().bottom;
        const navHeight = jumpNav.offsetHeight;

        if (top <= 0 && twoColumnsBottom > navHeight) {
            jumpNav.classList.add("visible", "fixed");
        } else {
            jumpNav.classList.remove("fixed");
        }

        if (top > 0) {
            jumpNav.classList.remove("visible");
        }

        updateActiveLink();
    });


    jumpLinks.forEach(link => {
        link.addEventListener('click', function (e) {
            e.preventDefault();

            const targetId = this.getAttribute('href').substring(1);

            if (window.innerWidth <= 768 && toggleButton) {
                toggleButton.textContent = this.textContent.trim();
                toggleButton.setAttribute('aria-expanded', 'false');
                jumpNav.classList.remove('jump-nav--open');
            }

            scrollToSection(targetId);
        });
    });

    if (toggleButton) {
        toggleButton.addEventListener('click', () => {
            const expanded = toggleButton.getAttribute('aria-expanded') === 'true';
            toggleButton.setAttribute('aria-expanded', String(!expanded));
            jumpNav.classList.toggle('jump-nav--open');
        });
    }

    function scrollToSection (id) {
        const targetEl = document.getElementById(id);
        if (!targetEl) return;

        if (window.innerWidth <= 768 && jumpNav.classList.contains('jump-nav--open')) {
            jumpNav.classList.remove('jump-nav--open');
            toggleButton.setAttribute('aria-expanded', 'false');

            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    doScroll();
                });
            });
        } else {
            doScroll();
        }

        function doScroll () {
            const navHeight = jumpNav.offsetHeight || 0;
            const adminBar = document.getElementById('wpadminbar');
            const adminHeight = adminBar ? adminBar.offsetHeight : 0;

            const offsetTop = window.innerWidth <= 768
                ? targetEl.getBoundingClientRect().top + window.pageYOffset + 17
                : targetEl.getBoundingClientRect().top + window.pageYOffset + navHeight - adminHeight;

            window.scrollTo({
                top: offsetTop,
                behavior: 'smooth'
            });

            setActiveLink(id);
        }
    }

    function setActiveLink (id) {
        jumpLinks.forEach(link => {
            const hrefId = link.getAttribute('href').substring(1);
            link.classList.toggle('active', hrefId === id);
        });
    }

    function updateActiveLink () {
        const scrollY = window.pageYOffset;
        const navHeight = jumpNav.offsetHeight || 0;
        const adminBar = document.getElementById('wpadminbar');
        const adminHeight = adminBar ? adminBar.offsetHeight : 0;

        let currentId = null;

        sections.forEach(section => {
            if (!section) return;

            const sectionTop = section.offsetTop - navHeight - adminHeight - 20;
            if (scrollY >= sectionTop) {
                currentId = section.id;
            }
        });

        if (currentId) {
            setActiveLink(currentId);
        }
    }
}